"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const withLazy_1 = __importDefault(require("../../decorators/withLazy"));
const YoutubePlayer = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "react-player-youtube" */ 'react-player/youtube')))));
const VimeoPlayer = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "react-player-vimeo" */ 'react-player/vimeo')))));
const BrightcovePlayer = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "@brightcove-react-player-loader" */ '@brightcove/react-player-loader')))));
const PlayerWrapper = styled_components_1.default.div `
  height: 100%;
  width: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
  .brightcove-react-player-loader {
    width: 100%;
    height: 100%;
    .video-js {
      height: 100%;
    }
  }
  .bc-player-default_default .vjs-control {
    color: #fff;
  }
`;
const TIME_UNTIL_USER_IS_CONSIDERED_IDLE = 30000;
const VideoPlayer = ({ startTransition, video, light = false, autoplay = true, muted = false, startContentAnimations = () => { }, stopContentAnimations = () => { }, onVideoEnd = () => { }, onVideoError = () => { }, onVideoReady = () => { }, mode, updateStore, }) => {
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const errorHandled = (0, react_1.useRef)(false);
    const params = new URLSearchParams(window.location.search);
    if (params.has('mute_video', 'true')) {
        muted = true;
    }
    const options = {
        url: video.value,
        width: '100%',
        height: '100%',
        light,
        playing: autoplay,
        muted,
        controls: mode === 'linear' ? false : true,
        volume: muted ? 0 : 1,
    };
    const brightcoveOptions = {
        autoplay,
        muted,
        controls: mode === 'linear' ? false : true,
        aspectRatio: '16:9',
    };
    const onVideoErrorHandler = () => {
        if (!errorHandled.current) {
            setHasError(true);
            errorHandled.current = true;
            onVideoError();
        }
    };
    const onVideoReadyHandler = () => {
        if (!hasError) {
            onVideoReady();
        }
    };
    (0, react_1.useEffect)(() => {
        updateStore('isBackgroundMusicMuted', true);
        return () => {
            errorHandled.current = false;
            updateStore('isBackgroundMusicMuted', false);
        };
    }, [video]);
    let brightcoveAccountId = '';
    let brightcoveVideoId = '';
    //@ts-ignore
    let idleTimer;
    if (video.videoType === 'brightcove') {
        brightcoveAccountId = video.value.split('/')[3];
        brightcoveVideoId = video.value.split('?videoId=')[1];
    }
    const onVideoEnded = () => {
        clearTimeout(idleTimer);
        startContentAnimations();
        onVideoEnd();
    };
    const onVideoPaused = () => {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(() => {
            startContentAnimations();
        }, TIME_UNTIL_USER_IS_CONSIDERED_IDLE);
        updateStore('isHeaderHidden', false);
    };
    const onVideoPlay = () => {
        clearTimeout(idleTimer);
        stopContentAnimations();
    };
    const playerProps = Object.assign(Object.assign({}, options), { onError: onVideoErrorHandler, onReady: onVideoReadyHandler, onPlay: () => { }, onPause: () => { }, onEnded: onVideoEnd });
    const onBrightcovePlayerLoad = player => {
        player.ref.on('ended', onVideoEnded);
        player.ref.on('pause', onVideoPaused);
        player.ref.on('play', onVideoPlay);
    };
    const transitionClass = startTransition ? 'start-transition' : '';
    if (process.env.PLATFORM !== 'ds') {
        return (react_1.default.createElement(PlayerWrapper, { "data-testid": "video-wrapper", className: `video-player ${transitionClass}` },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(react_1.default.Fragment, null) },
                video.videoType === 'vimeo' && (react_1.default.createElement(VimeoPlayer, Object.assign({}, options, { onError: onVideoErrorHandler, onReady: onVideoReadyHandler }))),
                video.videoType === 'youtube' && (react_1.default.createElement(YoutubePlayer, Object.assign({}, options, { onError: onVideoErrorHandler, onReady: onVideoReadyHandler }))),
                video.videoType === 'brightcove' && brightcoveAccountId && (react_1.default.createElement(BrightcovePlayer, { options: brightcoveOptions, accountId: brightcoveAccountId, videoId: brightcoveVideoId, onError: onVideoErrorHandler, onSuccess: onVideoReadyHandler })))));
    }
    return (react_1.default.createElement(PlayerWrapper, { "data-testid": "video-wrapper" },
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading video player...") },
            video.videoType === 'vimeo' && react_1.default.createElement(VimeoPlayer, Object.assign({}, playerProps)),
            video.videoType === 'youtube' && react_1.default.createElement(YoutubePlayer, Object.assign({}, playerProps)),
            video.videoType === 'brightcove' && (react_1.default.createElement(BrightcovePlayer, { options: brightcoveOptions, accountId: brightcoveAccountId, videoId: brightcoveVideoId, onSuccess: player => {
                    onBrightcovePlayerLoad(player);
                    onVideoReadyHandler();
                }, onError: onVideoErrorHandler })))));
};
const mapStoreToProps = store => ({
    mode: store.getValue('mode'),
    isHeaderHidden: store.getValue('isHeaderHidden'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(VideoPlayer));
